import activision from '../../img/activision.jpg';
import udemy from '../../img/udemy.jpg';
import tiktok from '../../img/tiktok.jpg';
import github from '../../img/github.jpg';
import fcc from '../../img/fcc.jpg';
import airbnb from '../../img/airbnb.jpg';
import google from '../../img/google.png';

const notifications = [
  {
    id: 1,
    img: activision,
    name: 'activision',
    when: '20m',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
  {
    id: 2,
    img: udemy,
    name: 'udemy',
    when: '27m',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
  {
    id: 3,
    img: tiktok,
    name: 'tiktok',
    when: '40m',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
  {
    id: 4,
    img: github,
    name: 'github',
    when: '1h',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
  {
    id: 5,
    img: fcc,
    name: 'fcc',
    when: '1d',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
  {
    id: 6,
    img: google,
    name: 'google',
    when: '2d',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
  {
    id: 7,
    img: airbnb,
    name: 'airbnb',
    when: '2d',
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint provident non a laboriosam mollitia repudiandae.',
  },
];

export default notifications;
